import axios from "axios";
import { SessionStore } from "../../../types/store";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/warehouse/equipment`;

export const getEquipmentImageBlob = async (
  equipmentId: number,
  imageId: number,
): Promise<Blob> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<Blob>(`${BASE_URL}/${equipmentId}/images/${imageId}`, {
    responseType: "blob",
    headers: { "x-access-token": session?.accessToken },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
  });

  return res.data;
};